module.exports = function () {
  return "\n    <div class=\"game-clock\">\n      <span id=\"game-clock-seconds\">00</span>.<span id=\"game-clock-miliseconds\">000</span>\n    </div>\n  ";
};